export default {
  workflow: {
    title: 'Workflow',
    heading: 'Privacy Protection Workflow',
    description: 'Complete privacy protection process from data input to verification output',
    steps: {
      dataInput: {
        title: 'Data Input',
        description: 'User inputs raw data',
        label: 'Raw Data'
      },
      encryption: {
        title: 'Encryption',
        description: 'Data encryption processing',
        label: 'Encrypted Data'
      },
      computation: {
        title: 'Computation',
        description: 'Privacy-protected computation',
        label: 'Secure Compute'
      },
      verification: {
        title: 'Verification',
        description: 'Zero-knowledge proof verification',
        label: 'ZK Proof'
      },
      output: {
        title: 'Output',
        description: 'Output verification results',
        label: 'Verified Result'
      }
    }
  },
  features: {
    title: 'Features',
    heading: 'Core Technical Features',
    description: 'Core functionality and technical features provided by the privacy protection layer'
  },
  useCases: {
    title: 'Use Cases',
    heading: 'Application Scenarios',
    description: 'Use cases of the privacy protection layer in real-world applications'
  },
  benefits: {
    title: 'Benefits',
    heading: 'Core Advantages',
    description: 'Core value and advantages brought by the privacy protection layer'
  },
  cta: {
    title: 'Start Building Privacy Protection Applications',
    description: 'Use Titron\'s privacy protection layer to build next-generation Web3 applications',
    button: 'Start Building'
  }
};
